<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'DATA_CYCLES', url: '/admin/data-cycles' },
    { label: 'SWITCH_DATA_CYCLE' }
  ]"
></breadcrumbs>

<page-header title="SWITCH_DATA_CYCLE"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="DATA_CYCLE">{{
        'DATA_CYCLE' | translate
      }}</label>
      <div class="control">
        <ng-select
          class="is-small"
          [items]="dataCycles$ | async"
          [multiple]="false"
          [clearable]="false"
          [closeOnSelect]="true"
          (change)="handleFieldChange($event?.id, 'dataCycleId')"
          [ngClass]="{ 'is-danger': hasError('dataCycleId') }"
          bindLabel="name"
          bindValue="id"
          [ngModelOptions]="{ standalone: true }"
          [ngModel]="getField(['dataCycleId'])"
        >
        </ng-select>
      </div>
      <p class="help is-danger" *ngIf="hasError('dataCycleId')">
        {{ getError('dataCycleId') }}
      </p>
    </div>

    <div class="py-4">
      <data-generation-section
        *ngFor="let stat of stats"
        [data]="stat"
      ></data-generation-section>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="
        isLoading ||
        checkIfRunning() ||
        getField(['forceStopReceived']) ||
        currentDataCycleId == getField(['dataCycleId'])
      "
      type="button"
      class="button is-success"
      (click)="start()"
      translationEditableDirective="START"
    >
      {{ 'START' | translate }}
    </button>
  </div>
  <div class="control">
    <button
      (click)="stop()"
      [disabled]="
        isLoading || !checkIfRunning() || getField(['forceStopReceived'])
      "
      type="button"
      class="button is-link is-light"
      translationEditableDirective="STOP"
    >
      {{ 'STOP' | translate }}
    </button>
  </div>
</div>
